import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { faTrafficLightStop } from '@fortawesome/pro-light-svg-icons';
import { TranslocoService } from '@ngneat/transloco';
import { AcModel } from '../../../models/ac.model';
import { ElementModel } from '../../../models/element.model';
import { PreparationModel } from '../../../models/preparation.model';
import { AuthStateService } from '../../../services/auth-state.service';
import { DataService } from '../../../services/data.service';
import { UiService } from '../../../services/ui.service';
import { AppService } from '../../../services/app.service';
import { SelectItem } from 'primeng/api';

@Component({
  selector: 'app-preparation',
  templateUrl: './preparation.component.html',
  styleUrls: ['./preparation.component.scss'],
})
export class PreparationComponent implements OnInit {

  public ac: AcModel = null;
  public preparation: PreparationModel = null;
  public element: ElementModel = null;
  public elements: Array<ElementModel> = [];
  public tabs: Array<SelectItem> = [];
  public activeTab: SelectItem = null;

  private preparationId: number = null;
  private elementId: number = null;

  public faTrafficLightStop = faTrafficLightStop;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private app: AppService,
    private data: DataService,
    private ui: UiService,
    private transloco: TranslocoService,
    public auth: AuthStateService
  ) {}

  ngOnInit(): void {
    this.ui.setPageTitle(this.transloco.translate('common.labels.preparation'));
    this.data.ac$.subscribe({
      next: (ac: AcModel) => {
        if (ac !== null) {
          this.ac = ac;
          this.data.setActiveNav('preparation');
          this.initElements();
        }
      }
    });
    this.route.params.subscribe((params) => {
      this.preparationId = parseInt(params.preparation, 10) || null;
      this.elementId = parseInt(params.element, 10) || null;
      this.initElements();
    });
  }

  public isEntitled(element: ElementModel = null): boolean {
    if (element === null) {
      element = this.element;
    }
    return (
      element !== null &&
      ((this.auth.isObserver() &&
        element.permissions.indexOf('observer') !== -1) ||
        (this.auth.isCandidate() &&
          element.permissions.indexOf('candidate') !== -1) ||
        this.auth.isModerator())
    );
  }

  public onTabChanged(tab: SelectItem): void {
    this.router.navigate(['/ac/preparation', this.preparationId, 'elements', tab.value]);
  }

  private initElements(): void {
    this.element = null;
    this.tabs = [];
    if (this.ac && this.preparationId) {
      this.preparation = this.ac.getPreparationOnId(this.preparationId);
      if (this.preparation !== null) {
        this.elements = this.preparation.elements.filter((element: ElementModel) => {
          return this.isEntitled(element);
        });
        if (this.elements.length > 0) {
          this.element = this.elements.find((element: ElementModel) => {
            return element.id === this.elementId;
          }) || this.elements[0] || null;
          this.tabs = this.elements.map((element: ElementModel) => {
            return {
              value: element.id,
              label: element.title || element.name
            };
          });
        }
        if (this.element) {
          this.activeTab = this.tabs.find((tab: SelectItem) => {
            return tab.value === this.element.id;
          });
        } else {
          this.app.redirectToDashboard();
        }
      } else {
        this.app.redirectToDashboard();
      }
    }
  }

}
